module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-collapse', {
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, _vm._l((_vm.list), function(goods, index) {
    return _c('van-collapse-item', {
      attrs: {
        "name": index
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function() {
          return [_c('div', [_vm._v(_vm._s(goods.title) + " ")])]
        },
        proxy: true
      }, {
        key: "value",
        fn: function() {
          return [(goods.count > 0) ? _c('div', [_vm._v(_vm._s(goods.count) + "件 ")]) : _vm._e()]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_vm._v("\n                            " + _vm._s(goods.desc) + "\n                            "), _c('div', {
      staticClass: "cf"
    })]), _vm._v(" "), _vm._l((goods.items), function(item, iindex) {
      return _c('van-card', {
        attrs: {
          "price": item.price + '/' + item.unit,
          "title": item.title
        },
        scopedSlots: _vm._u([{
          key: "tags",
          fn: function() {
            return [_c('img', {
              attrs: {
                "src": item.pic_url,
                "alt": ""
              }
            }), _vm._v(" "), _c('div', [_vm._v("小记  ¥" + _vm._s(item.total_price))])]
          },
          proxy: true
        }, {
          key: "num",
          fn: function() {
            return [(item.user_buy_limit > 0) ? _c('van-stepper', {
              attrs: {
                "min": 0,
                "max": item.user_buy_limit,
                "theme": "round",
                "name": index + ',' + iindex,
                "disable-input": "",
                "input-width": "40px",
                "button-size": "32px"
              },
              on: {
                "change": _vm.onCountChange
              },
              model: {
                value: (item.count),
                callback: function($$v) {
                  _vm.$set(item, "count", $$v)
                },
                expression: "item.count"
              }
            }) : _c('van-stepper', {
              attrs: {
                "min": 0,
                "theme": "round",
                "name": index + ',' + iindex,
                "disable-input": "",
                "input-width": "40px",
                "button-size": "32px"
              },
              on: {
                "change": _vm.onCountChange
              },
              model: {
                value: (item.count),
                callback: function($$v) {
                  _vm.$set(item, "count", $$v)
                },
                expression: "item.count"
              }
            })]
          },
          proxy: true
        }], null, true)
      })
    })], 2)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认申报")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29a73f9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/songpei/SongpeiApplyFormStep2.vue
// module id = 2293
// module chunks = 0